import { createContext, useContext } from 'react'
import type { LocalStore } from '@/platform/localStore'
import type { MissionRepository, PresencePosition } from './MissionRepository'
import type { PresenceState } from './presence/PresenceBeat'
import type { PositionSync, SyncResult } from './tracking/PositionSync'

export interface OperatorServices {
  userId: string
  repository: MissionRepository
  store: LocalStore
  sync: PositionSync
  /** Dernier résultat d'envoi (positions en attente, erreur réseau ou refus). */
  syncState: SyncResult | null
  flush: () => Promise<SyncResult>
  /** Présence de la tablette (battement 30 s), disponibilité déclarée comprise. */
  presence: PresenceState
  /** Disponibilité confirmée par le serveur : l'état local ne change qu'après sa réponse. */
  setPresenceAvailable: (available: boolean) => void
  /** Dernière mesure réelle du GPS, ou null (jamais une position inventée). */
  latestPosition: () => PresencePosition | null
  /** Déconnexion explicite de la présence, avant la fermeture de session. */
  disconnectPresence: () => Promise<void>
}

export const OperatorContext = createContext<OperatorServices | null>(null)

export function useOperator(): OperatorServices {
  const value = useContext(OperatorContext)
  if (!value) throw new Error('useOperator hors de OperatorProvider')
  return value
}
